export class SearchParams{
    public Term: string;
    public Field: string;
    public Term2: string;
    public Field2: string;
    public Radius: number;
    public IsRadiusSearch: boolean;
    constructor(term: string, field: string, term2: string, field2: string, radius: number, isRadiusSearch){
        this.Term = term;
        this.Field = field;
        this.Term2 = term2;
        this.Field2 = field2;
        this.Radius = radius;
        this.IsRadiusSearch = isRadiusSearch
    }
}